import { render, staticRenderFns } from "./Emptiontrade.vue?vue&type=template&id=13148914"
import script from "./Emptiontrade.vue?vue&type=script&lang=js"
export * from "./Emptiontrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports